import React, { useEffect } from 'react';
import {
  CodingLanguage,
  ExecutableLessonFile,
} from '@customtypes/parsedLesson';
import CssIconComponent from '../icons/cssIcon';
import Html5IconComponent from '../icons/html5Icon';
import JavascriptIconComponent from '../icons/javscriptIcon';
import ReactIconComponent from '../icons/reactIcon';
import SQLIconComponent from '../icons/sqlIcon';
import PythonIconComponent from '@components/icons/pythonIcon';

export function CodeEditorTabBar({
  files,
  selectedFileIndex,
  setSelectedFileIndex,
}: {
  files: ExecutableLessonFile[];
  selectedFileIndex: number;
  setSelectedFileIndex: (fileIndex: number) => void;
}) {
  useEffect(() => {
    const selectedFileElement = document.getElementById(
      `file-${selectedFileIndex}`,
    );
    selectedFileElement?.scrollIntoView({ behavior: 'smooth' });
  }, [selectedFileIndex]);

  return (
    <div
      translate="no"
      className={`flex h-full flex-shrink-0 flex-grow overflow-x-auto bg-product2-background-secondary`}
    >
      {files.map((file, index) => {
        return (
          <button
            id={`file-${index}`}
            key={file.name}
            disabled={files[selectedFileIndex]?.name === file.name}
            onClick={() => setSelectedFileIndex(index)}
            className={`group flex h-full items-center justify-center space-x-2 whitespace-nowrap border-r ${
              selectedFileIndex === index || selectedFileIndex === index + 1
                ? 'border-r-transparent'
                : ''
            } border-t border-r-product2-border-secondary px-4 text-xs font-semibold text-product-text-primary-dark hover:border-t-product-accent-important-dark ${
              selectedFileIndex === index
                ? `border-t-product-accent-important-dark bg-product2-background-dark`
                : `border-product2-border-secondary`
            }`}
          >
            {getFileTabIcon(file.codeLanguage)}
            <div>{file.name}</div>
          </button>
        );
      })}
      <div className="flex grow border-t border-product2-border-secondary"></div>
    </div>
  );
}

function getFileTabIcon(codeLanguage: CodingLanguage) {
  switch (codeLanguage) {
    case 'html':
      return (
        <Html5IconComponent grayscale className="h-4 w-4"></Html5IconComponent>
      );
    case 'css':
      return (
        <CssIconComponent grayscale className="h-4 w-4"></CssIconComponent>
      );
    case 'javascript':
      return (
        <JavascriptIconComponent
          grayscale
          className="h-4 w-4"
        ></JavascriptIconComponent>
      );
    case 'jsx':
      return (
        <ReactIconComponent grayscale className="h-4 w-4"></ReactIconComponent>
      );
    case 'sql':
      return (
        <SQLIconComponent grayscale className="h-4 w-4"></SQLIconComponent>
      );
    case 'python':
      return (
        <PythonIconComponent
          grayscale
          className="h-4 w-4 grayscale"
        ></PythonIconComponent>
      );

    default:
      break;
  }
}
